import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Switch, Route } from "react-router-dom";
import { checkUserSession } from './redux/User/user.actions';


//hoc
import WithAuth from './hoc/withAuth'
import WithAdminAuth from './hoc/withAdminAuth'
import WithVendorAuth from './hoc/withVendorAuth';

//layouts
import HomepageLayout from './layouts/HomePageLayout';
import MainLayout from './layouts/MainLayout';
import AdminLayout from './layouts/AdminLayout';
import DashboardLayout from './layouts/DashboardLayout';
import VendorDashLayout from './layouts/VendorDashLayout';

//pages
import Admin from './pages/Admin';
import HomePage from './pages/Homepage';
import Plans from './pages/Plans';
import Recovery from './pages/Recovery';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';

//Customer Pages
import Login from './pages/Login';
import Registration from './pages/Registration';
import Dashboard from './pages/Dashboard';
import AcctDetails from './pages/AcctDetails';
import EditAcctDetails from './pages/EditAcctDetails';
import Billing from './pages/Billing';
import Services from './pages/Services';
import Subscribe from './pages/Subscribe';
import Contact from './pages/Contact';
import NeededService from './pages/NeededService';
import Invoices from './pages/Invoices';
import Receipts from './pages/Receipts';
import Calendar from './pages/Calendar';
import Unsubscribe from './pages/Unsubscribe';
import Conversations from './pages/Conversations';
import Cart from './pages/Cart';
import Payment from './pages/Payment';
import Order from './pages/Order';
import Conversation from './pages/Conversation';
import CustomersServicesChat from './pages/CustomersServicesChat';
import CustomerAppt from './pages/CustomerAppt';

//Vendor Pages
import VendorRegistration from './pages/VendorRegistration';
import VendorLogin  from './pages/VendorLogin';
import VendorDashboard from './pages/VendorDashboard';
import VendorAcctDetails from './pages/VendorAcctDetails';
import VendorEditAcctDetails from './pages/VendorEditAcctDetails';
import VendorConversations from './pages/VendorConversations';
import VendorQuotes from './pages/VendorQuotes';
import VendorInvoices from './pages/VendorInvoices';
import VendorReceipts from './pages/VendorReceipts';
import VendorMap from './pages/VendorMap';
import VendorServices from './pages/VendorServices';
import VendorContact from './pages/VendorContact';
import VendorAppointments from './pages/VendorAppointments';
import VendorAppointment from './pages/VendorAppointment';
import VendorEditAppt from './pages/VendorEditAppt';
import VendorConversation from './pages/VendorConversation';
import CustomerMap from './pages/CustomerMap';

//Components
import * as ROUTES from './components/Routes';



const App = props => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkUserSession());
    // eslint-disable-next-line
  }, []);

  return (
      <div className="App">
        <Switch>
          
          <Route exact path={ROUTES.LANDING} render={() => (
              <HomepageLayout>
                <HomePage />
              </HomepageLayout>
            )}
          />
          <Route path={ROUTES.PLANS} render={() => (
              <MainLayout >
                <Plans />
              </MainLayout>
            )}
          />
          <Route path={ROUTES.TERMS_AND_CONDITIONS} render={() => (
              <MainLayout >
                <TermsAndConditions />
              </MainLayout>
            )}
          />
          <Route path={ROUTES.PRIVACY_POLICY} render={() => (
              <MainLayout >
                <PrivacyPolicy />
              </MainLayout>
            )}
          />
          <Route path={ROUTES.PASSWORD_FORGET} render={() => ( 
              <MainLayout>
                <Recovery />
              </MainLayout>
            )}
          />
          <Route path={ROUTES.ADMIN} render={() => (
              <WithAdminAuth>
                <AdminLayout>
                  <Admin />
                </AdminLayout>
              </WithAdminAuth>
            )}
          />


          {/* CUSTOMER */}
          <Route path={ROUTES.LOGIN} render={() => (
              <MainLayout >
                <Login />
              </MainLayout>
            )}
          />
          <Route path={ROUTES.REGISTRATION} render={() => (
              <MainLayout >
                <Registration/>
              </MainLayout>
            )}
          />
          <Route path={ROUTES.DASHBOARD} render={() => (
              <WithAuth>
                <DashboardLayout>
                  <Dashboard/>
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.ACCT_DETAILS} render={() => (
              <WithAuth>
                <DashboardLayout>
                  <AcctDetails/>
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.EDIT_ACCT_DETAILS} render={() => (
              <WithAuth>
                <DashboardLayout>
                  <EditAcctDetails/>
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.BILLING} render={() => (
              <WithAuth>
                <DashboardLayout>
                  <Billing/>
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.SERVICES} render={() => (
              <WithAuth>
                <DashboardLayout>
                  <Services/>
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.SUBSCRIBE} render={() => (
              <WithAuth>
                <DashboardLayout>
                  <Subscribe/>
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.CONTACT} render={() => (
              <WithAuth>
                <DashboardLayout >
                  <Contact />
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.NEEDED_SERVICE} render={() => (
              <WithAuth>
                <DashboardLayout >
                  <NeededService />
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.INVOICES} render={() => (
              <WithAuth>
                <DashboardLayout >
                  <Invoices />
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.RECEIPTS} render={() => (
              <WithAuth>
                <DashboardLayout >
                  <Receipts />
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.CALENDAR} render={() => (
              <WithAuth>
                <DashboardLayout >
                  <Calendar />
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.UNSUBSCRIBE} render={() => (
              <WithAuth>
                <DashboardLayout >
                  <Unsubscribe />
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.CONVERSATIONS} render={() => (
              <WithAuth>
                <DashboardLayout >
                  <Conversations />
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.CART} render={() => (
              <WithAuth>  
                <DashboardLayout >
                  <Cart />
                </DashboardLayout >
              </WithAuth>
            )}
          />
          <Route path={ROUTES.PAYMENT} render={() => (
              <WithAuth>  
                <DashboardLayout >
                  <Payment />
                </DashboardLayout >
              </WithAuth>
            )}
          />
          <Route path={ROUTES.ORDER} render={() => (
              <WithAuth>  
                <DashboardLayout >
                  <Order />
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.CONVERSATION} render={() => (
              <WithAuth>  
                <DashboardLayout >
                  <Conversation />
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.CUSTOMERS_SERVICES_CHAT} render={() => (
              <WithAuth>  
                <DashboardLayout >
                  <CustomersServicesChat />
                </DashboardLayout>
              </WithAuth>
            )}
          />
          <Route path={ROUTES.CUSTOMER_APPT} render={() => (
              <WithAuth>  
                <DashboardLayout >
                  <CustomerAppt />
                </DashboardLayout>
              </WithAuth>
            )}
          />
          

          {/* VENDOR */}
          <Route path={ROUTES.VENDOR_LOGIN} render={() => (
              <MainLayout >
                <VendorLogin/>
              </MainLayout>
            )}
          />
          <Route path={ROUTES.VENDOR_REGISTRATION} render={() => (
              <MainLayout >
                <VendorRegistration/>
              </MainLayout>
            )}
          />
          <Route path={ROUTES.VENDOR_DASHBOARD} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorDashboard />
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.VENDOR_ACCT_DETAILS} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorAcctDetails />
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.VENDOR_EDIT_ACCT_DETAILS} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorEditAcctDetails />
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.VENDOR_CONVERSATIONS} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorConversations/>
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.VENDOR_QUOTES} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorQuotes/>
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.VENDOR_INVOICES} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorInvoices/>
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.VENDOR_RECEIPTS} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorReceipts/>
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.VENDOR_MAPS} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorMap/>
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.VENDOR_SERVICES} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorServices/>
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.VENDOR_CONTACT} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorContact/>
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.VENDOR_APPTS} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorAppointments/>
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.VENDOR_APPT} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorAppointment/>
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.VENDOR_EDIT_APPT} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorEditAppt/>
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />


          <Route path={ROUTES.VENDOR_CONVERSATION} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <VendorConversation/>
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          <Route path={ROUTES.CUSTOMER_MAP} render={() => (
              <WithVendorAuth>
                <VendorDashLayout>
                  <CustomerMap/>
                </VendorDashLayout>
              </WithVendorAuth>
            )}
          />
          
        </Switch>
      </div>
  );
}

export default App;
